export default __webpack_public_path__ + "static/media/img-slider-om-wallet-3.f16a9992.png";